import {Routes} from '@angular/router';

/**
 * Created by Rsierra.
 *
 * Application routes.
 * Agregar las rutas que se desean cargar, usando la carga asincrona, permitiendo optimizar
 * los tiepos de carga y rendimiento de la aplicación.
 * @routesApp Arreglo de rutas de la aplicación.
 */
const routesApp: Routes = [
  {
    path: 'dashboard',
    loadChildren: 'app/dashboard/dashboard.module#DashboardModule'
  },
  {
    path: 'reports',
    loadChildren: 'app/reports/reports.module#ReportsModule'
  },
  {
    path: 'documents',
    loadChildren: 'app/documents/documents.module#DocumentsModule'
  },
  {
    path: 'directory',
    loadChildren: 'app/directory/directory.module#DirectoryModule'
  },
  {
    path: 'settings',
    loadChildren: 'app/ajustes/ajustes.module#AjustesModule'
  },
  {
  path: 'calendar',
  loadChildren: 'app/calendar/calendar.module#CalendaryModule'
  },
  {
    path: 'catalogos',
    loadChildren: 'app/catalogos/catalogos.module#CatalogosModule'
  }
];

export const RoutesApplications = [...routesApp];



// WEBPACK FOOTER //
// ./src/app/app.routes.ts